<template lang="html">
  <div v-if="loading" class="loading-wrapper" :class="{small: appSmall}">
    <v-progress-circular
      :size="30"
      color="primary"
      indeterminate
    />
  </div>
  <v-select
    v-else
    :value="castedValue"
    :items="machineList"
    :label="`Select Machine${multiple ? '(s)' : ''}`"
    :multiple="multiple"
    :light="light"
    :dark="dark"
    @input="update"
    :append-icon="multiple && value && value.length ? 'fa-times' : undefined"
    @click:append="clearAll"
    single-line
    hide-details
    dense
    :outlined="outlined"
    ref="selectComponent"
  >
    <template v-slot:prepend-item v-if="multiple">
      <v-list-item
        ripple
        @click="selectAll"
      >
        <v-list-item-action>
          <v-icon :color="value && value.length > 0 ? 'primary' : ''">{{ selectAllIcon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Select All</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <div v-if="multiple">
        <div v-if="!numChips && index === 0">
          <span>{{ value.length }} selected</span>
        </div>
        <div v-else-if="!!numChips">
          <v-chip v-if="index < numChips" small>
            <span># {{ item.value }}</span>
          </v-chip>
          <span
            v-if="value && value.length && index === numChips"
            class="caption"
          >(+{{ value.length - numChips }}{{numChips > 1 ? ' more' : ''}})</span>
        </div>
      </div>
      <div class="selection-label" :class="{small: appSmall}" v-else>{{ item.text }}</div>
    </template>
  </v-select>
</template>

<style lang="scss" scoped>
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.selection-label.small {
  max-width: 30vw;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      default () {
        if (this.multiple) {
          return []
        }
        return null
      }
    },
    dark: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    noTopPadding: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    numChips () {
      return this.appSmall ? 1 : 3
    },
    ...mapState('machines', {
      machines: 'data',
      loading: 'loading'
    }),
    machineList () {
      return this.machines.map(m => ({
        text: `# ${m.id} ${m.name ? '(' + m.name + ')' : ''}`,
        value: m.id + ''
      }))
    },
    selectAllIcon () {
      if (!this.multiple) {
        return
      }
      if (this.value && this.value.length === this.machines.length) {
        return 'fa-check-square'
      } else if (this.value && this.value.length) {
        return 'fa-minus-square'
      }
      return 'fa-square'
    },
    castedValue () {
      if (this.value && Array.isArray(this.value)) {
        return this.value.map(v => v + '')
      } else if (this.value) {
        return this.value + ''
      }
      return this.value
    }
  },
  methods: {
    update (value) {
      this.$emit('input', value)
    },
    clearAll ($event) {
      $event.stopPropagation()
      this.$emit('input', [])
    },
    selectAll () {
      if (this.value && this.value.length) {
        this.update([])
      } else {
        this.update(this.machines.map(m => m.id))
        this.$refs.selectComponent.blur()
      }
    }
  }
}
</script>
